module.exports = __webpack_public_path__ + "images/accents/accent-sl3-interactions-78fe734c32ca01dedf6f444d0f71a23b.webp";